/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import {
  COUNTRY,
  GROUND_MOTION_METHOD,
  GROUND_MOTION_UPLOAD,
  HAZARD_EDITION,
  INCLUDE_DESIGN_INTENSITIES,
  RETURN_PERIODS,
  RETURN_PERIOD_DE,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import {
  selectRunOutputDBE,
  selectRunOutputMCE,
  selectHasGroundMotionData,
  selectIsGroundMotionMatch,
  selectRunOutputGroundMotionClosestVs30,
} from '#selectors/entities/models.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import GroundMotionSection from './GroundMotionSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { modelId, form } = ownProps;
  const { selectFormValues, selectFormFieldVisibility } = modelTypesByForm[form];
  const {
    [COUNTRY]: country,
    [GROUND_MOTION_METHOD]: method,
    [GROUND_MOTION_UPLOAD]: upload,
    [INCLUDE_DESIGN_INTENSITIES]: includeDesignIntensities,
  } = selectFormValues(
    state,
    INCLUDE_DESIGN_INTENSITIES,
    GROUND_MOTION_METHOD,
    GROUND_MOTION_UPLOAD,
    COUNTRY,
    'groundMotionClosestVs30'
  );

  const isGroundMotionMatch = selectIsGroundMotionMatch(state, { modelId, method, upload });
  const hasGroundMotionData = selectHasGroundMotionData(state, { modelId });

  return {
    country,
    dbe: selectRunOutputDBE(state, { modelId }),
    mce: selectRunOutputMCE(state, { modelId }),
    groundMotionClosestVs30: selectRunOutputGroundMotionClosestVs30(state, { modelId }),
    showDesignIntensities: includeDesignIntensities === true,
    showGroundMotionTable: isGroundMotionMatch && hasGroundMotionData,
    showHazardEdition: selectFormFieldVisibility(state)(HAZARD_EDITION),
    showIncludeDesignIntensities: selectFormFieldVisibility(state)(INCLUDE_DESIGN_INTENSITIES),
    showReturnPeriods: selectFormFieldVisibility(state)(RETURN_PERIODS),
    showReturnPeriodDEandMCE:
      isGroundMotionMatch &&
      hasGroundMotionData &&
      selectFormFieldVisibility(state)(RETURN_PERIOD_DE),
    showUploader: selectFormFieldVisibility(state)(GROUND_MOTION_UPLOAD),
  };
};

const GroundMotionContainer = connect(mapStateToProps)(GroundMotionSection);

export default GroundMotionContainer;
